import { render, staticRenderFns } from "./modal-change-password.vue?vue&type=template&id=8434af36&scoped=true"
import script from "./modal-change-password.vue?vue&type=script&lang=js"
export * from "./modal-change-password.vue?vue&type=script&lang=js"
import style0 from "./modal-change-password.vue?vue&type=style&index=0&id=8434af36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8434af36",
  null
  
)

export default component.exports